// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookDisplay_container__Sg2it {
  padding: 0px;
  background-color: #1a1a1a;
  max-height: 120vh;
  max-width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  color: #e5e5e5;
  line-height: 1.2;
  font-family: Raleway, sans-serif;
  font-weight: 400;
  margin: 0 auto;
  }
  
  .BookDisplay_featuredBook__TRlFz {
    background-color: #4E4848;
    border-radius: 12px;
    margin-bottom: 30px;
    position: relative;
    margin-top: 10rem;
    max-width: 1400px;
    width: 100%;
    height: 400px;
  }
  
  .BookDisplay_featuredImage__gW4my {
    width: auto;
    height: 250px;
    object-fit: cover;
    position: relative;
    bottom: 5rem;
    left: 3rem;
    border-radius: 15px;
  }
  
  .BookDisplay_featuredContent__IKu47 {
    padding: 20px;
    position: relative;
    bottom: 7.5rem;
  }
  
  .BookDisplay_bookTitle__su4\\+K {
    font: small-caps bold 46px Georgia, serif;
    font-optical-sizing: auto;
    font-size: 48px;
    font-weight:800;
    font-style: normal;
    margin-bottom: 10px;
  }
  
  .BookDisplay_bookInfo__SoC4C {
    color: #a0a0a0;
    font-size: 14px;
    margin-bottom: 20px;
  }
  
  .BookDisplay_bookmarkIcon__RbjAM {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.5);
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
  }
  
  .BookDisplay_bookmarkIcon2__cnu2l {
    display: flex;
    padding: 10px;
    align-items: end;
  }
  
  .BookDisplay_bookmarkButton__EeCcn {
    width: 30px;
    border: none;
    height: 30px;
    border-radius: 50%;
    background-color: red;
    position: absolute;
    right: 2%;
  }
  
  .BookDisplay_recommendedSection__BhWgb {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  .BookDisplay_sectionTitle__8NBcV {
    font-size: 22px;
    margin-bottom: 20px;
  }
  
  .BookDisplay_bookCard__mMRzP {
    background-color: #4E4848;
    border-radius: 12px;
    position: relative;
    display: flex;
    gap: 20px;
    height: 100%;
    max-height: 170px;
    padding-top: 5px;
  }
  
  .BookDisplay_cardImage__\\+nLk4 {
    width: 100%;
    height: 150px;
    object-fit: cover;
    position: relative;
    bottom: 2rem;
    left: 1rem;
    border-radius: 15px;
    max-width: 120px;
    max-height: 150px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 138%), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
  }
  
  .BookDisplay_cardContent__nh16Q {
    padding: 15px;
    min-width: 150px;
  }
  
  .BookDisplay_cardTitle__058PE {
    font-size: 16px;
    margin-bottom: 5px;
  }
  
  .BookDisplay_cardInfo__tmGns {
    color: #a0a0a0;
    font-size: 12px;
  }
  
  .BookDisplay_swiperContainer__W\\+E5U {
    padding-top: 2rem;
    margin-top: 1rem;
    height: auto /* Adjust based on your layout */
  }
  
  .BookDisplay_swiperContainer__W\\+E5U .swiper-button-next,
  .BookDisplay_swiperContainer__W\\+E5U .swiper-button-prev {
    color: white;
  }
  
  .BookDisplay_swiperContainer__W\\+E5U .swiper-pagination-bullet {
    background: white;
  }
  
  .BookDisplay_swiperContainer__W\\+E5U .swiper-pagination-bullet-active {
    background: red;
  }
  .BookDisplay_bookmarkButton__EeCcn.BookDisplay_bookmarked__vyzLH {
    background-color: #FF0000;
  }
  
  @media (max-width: 820px) {
    .BookDisplay_container__Sg2it {
      padding: 30px;
    }
  
    .BookDisplay_featuredImage__gW4my {
      height: 250px;
      left: 1.5rem;
    }
    
  }
  
  @media (max-width: 480px) {
    .BookDisplay_container__Sg2it {
      padding: 10px 20px;
    }
  
    .BookDisplay_featuredImage__gW4my {
      height: 200px;
      left: 1rem;
    }
  
    .BookDisplay_featuredBook__TRlFz {
      margin-top: 10rem;
      margin-left: 0rem;
      height: 200px;
    }
  
    .BookDisplay_bookTitle__su4\\+K {
      font-size: 18px;
    }
    .BookDisplay_bookCard__mMRzP{
      max-height: 150px;
    }

    .BookDisplay_swiperContainer__W\\+E5U {
      height: 160px; /* Adjust based on your layout */
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/components/Css/BookDisplay.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,0EAA0E;EAC5E;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW,EAAE,gCAAgC;EAC/C;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,YAAY;IACd;;EAEF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,UAAU;IACZ;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;MACjB,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa,EAAE,gCAAgC;IACjD;EACF","sourcesContent":[".container {\n  padding: 0px;\n  background-color: #1a1a1a;\n  max-height: 120vh;\n  max-width: 95%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 20px;\n  color: #e5e5e5;\n  line-height: 1.2;\n  font-family: Raleway, sans-serif;\n  font-weight: 400;\n  margin: 0 auto;\n  }\n  \n  .featuredBook {\n    background-color: #4E4848;\n    border-radius: 12px;\n    margin-bottom: 30px;\n    position: relative;\n    margin-top: 10rem;\n    max-width: 1400px;\n    width: 100%;\n    height: 400px;\n  }\n  \n  .featuredImage {\n    width: auto;\n    height: 250px;\n    object-fit: cover;\n    position: relative;\n    bottom: 5rem;\n    left: 3rem;\n    border-radius: 15px;\n  }\n  \n  .featuredContent {\n    padding: 20px;\n    position: relative;\n    bottom: 7.5rem;\n  }\n  \n  .bookTitle {\n    font: small-caps bold 46px Georgia, serif;\n    font-optical-sizing: auto;\n    font-size: 48px;\n    font-weight:800;\n    font-style: normal;\n    margin-bottom: 10px;\n  }\n  \n  .bookInfo {\n    color: #a0a0a0;\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n  \n  .bookmarkIcon {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: rgba(0, 0, 0, 0.5);\n    padding: 8px;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n  \n  .bookmarkIcon2 {\n    display: flex;\n    padding: 10px;\n    align-items: end;\n  }\n  \n  .bookmarkButton {\n    width: 30px;\n    border: none;\n    height: 30px;\n    border-radius: 50%;\n    background-color: red;\n    position: absolute;\n    right: 2%;\n  }\n  \n  .recommendedSection {\n    width: 100%;\n    margin-bottom: 0.5rem;\n  }\n  \n  .sectionTitle {\n    font-size: 22px;\n    margin-bottom: 20px;\n  }\n  \n  .bookCard {\n    background-color: #4E4848;\n    border-radius: 12px;\n    position: relative;\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    max-height: 170px;\n    padding-top: 5px;\n  }\n  \n  .cardImage {\n    width: 100%;\n    height: 150px;\n    object-fit: cover;\n    position: relative;\n    bottom: 2rem;\n    left: 1rem;\n    border-radius: 15px;\n    max-width: 120px;\n    max-height: 150px;\n    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 138%), 0 6px 20px 0 rgba(0, 0, 0, 0.2);\n  }\n  \n  .cardContent {\n    padding: 15px;\n    min-width: 150px;\n  }\n  \n  .cardTitle {\n    font-size: 16px;\n    margin-bottom: 5px;\n  }\n  \n  .cardInfo {\n    color: #a0a0a0;\n    font-size: 12px;\n  }\n  \n  .swiperContainer {\n    padding-top: 2rem;\n    margin-top: 1rem;\n    height: auto /* Adjust based on your layout */\n  }\n  \n  .swiperContainer :global(.swiper-button-next),\n  .swiperContainer :global(.swiper-button-prev) {\n    color: white;\n  }\n  \n  .swiperContainer :global(.swiper-pagination-bullet) {\n    background: white;\n  }\n  \n  .swiperContainer :global(.swiper-pagination-bullet-active) {\n    background: red;\n  }\n  .bookmarkButton.bookmarked {\n    background-color: #FF0000;\n  }\n  \n  @media (max-width: 820px) {\n    .container {\n      padding: 30px;\n    }\n  \n    .featuredImage {\n      height: 250px;\n      left: 1.5rem;\n    }\n    \n  }\n  \n  @media (max-width: 480px) {\n    .container {\n      padding: 10px 20px;\n    }\n  \n    .featuredImage {\n      height: 200px;\n      left: 1rem;\n    }\n  \n    .featuredBook {\n      margin-top: 10rem;\n      margin-left: 0rem;\n      height: 200px;\n    }\n  \n    .bookTitle {\n      font-size: 18px;\n    }\n    .bookCard{\n      max-height: 150px;\n    }\n\n    .swiperContainer {\n      height: 160px; /* Adjust based on your layout */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BookDisplay_container__Sg2it`,
	"featuredBook": `BookDisplay_featuredBook__TRlFz`,
	"featuredImage": `BookDisplay_featuredImage__gW4my`,
	"featuredContent": `BookDisplay_featuredContent__IKu47`,
	"bookTitle": `BookDisplay_bookTitle__su4+K`,
	"bookInfo": `BookDisplay_bookInfo__SoC4C`,
	"bookmarkIcon": `BookDisplay_bookmarkIcon__RbjAM`,
	"bookmarkIcon2": `BookDisplay_bookmarkIcon2__cnu2l`,
	"bookmarkButton": `BookDisplay_bookmarkButton__EeCcn`,
	"recommendedSection": `BookDisplay_recommendedSection__BhWgb`,
	"sectionTitle": `BookDisplay_sectionTitle__8NBcV`,
	"bookCard": `BookDisplay_bookCard__mMRzP`,
	"cardImage": `BookDisplay_cardImage__+nLk4`,
	"cardContent": `BookDisplay_cardContent__nh16Q`,
	"cardTitle": `BookDisplay_cardTitle__058PE`,
	"cardInfo": `BookDisplay_cardInfo__tmGns`,
	"swiperContainer": `BookDisplay_swiperContainer__W+E5U`,
	"bookmarked": `BookDisplay_bookmarked__vyzLH`
};
export default ___CSS_LOADER_EXPORT___;
